import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import SaleOrderRequestFileLine from '../entities/sale-order-file-line'
import Ajax from '../../lib/ajax'
import util from '@/lib/util';
import appconst from './../../lib/appconst';
import _ from 'lodash';
import PageResult from '@/store/entities/page-result';

interface SaleOrderImportState extends ListState<SaleOrderRequestFileLine> {
    itemsImported: Array<SaleOrderRequestFileLine>,
    countItems: number,
    countImportedItems: number
}
class SaleOrderImportModule extends ListModule<SaleOrderImportState, any, SaleOrderRequestFileLine>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<SaleOrderRequestFileLine>(),
        loading: false,
        itemsImported: new Array<SaleOrderRequestFileLine>(),
        countItems: 0,
        countImportedItems: 0
    }
    actions = {
        async getAll(context: ActionContext<SaleOrderImportState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoFileLine/GetAll', { params: payload.data });
            context.state.loading = false;
            const page = result as PageResult<SaleOrderRequestFileLine>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async uploadImportSaleOrderFile(context: ActionContext<SaleOrderImportState, any>, data: any) {
            let reponse = await Ajax.post('/api/services/app/SoFile/ImportSos', data);
            return reponse.data.result;
        },
        async export(context:ActionContext<SaleOrderImportState,any>,payload:any){
            window.open(`${appconst.remoteServiceBaseUrl}import/exportImportSos/`+payload.data, "_blank");    
        }
    };
    mutations = {
        setCurrentPage(state: SaleOrderImportState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: SaleOrderImportState, pagesize: number) {
           
            state.pageSize = pagesize;
        },
        setCountItems(state: SaleOrderImportState, count: number) {
            state.countItems = count;
        },
        setCountImportedItems(state: SaleOrderImportState, count: number) {
            state.countImportedItems = count;
        },
        processNotifier(state: SaleOrderImportState, payload: any) {
            if (payload.data != null) {
                if (payload.data.data != undefined && payload.data.data != null) {
                    const soLines = payload.data.data as Array<SaleOrderRequestFileLine>;
                    state.list = soLines;
                }
                if (!util.isNull(payload.data.countLine) && payload.data.countLine > 0) {
                    state.totalCount = payload.data.countLine as number;
                    state.currentPage = 1;
                }
                if (payload.data.countSo != undefined && payload.data.countSo != null && payload.data.countSo > 0) {
                    state.countItems = payload.data.countSo as number;
                }
                if (payload.data.soImported != undefined && payload.data.soImported != null && payload.data.soImported> 0) {
                    state.countImportedItems = payload.data.soImported as number;
                }
            }
        },
        resetList(state: SaleOrderImportState) {
            state.itemsImported = new Array<SaleOrderRequestFileLine>();
        },
        pageChangeItemsImported(state: SaleOrderImportState) {
            state.list = util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
        }
    }
}
const saleOrderImportModule = new SaleOrderImportModule();
export default saleOrderImportModule;